import React from "react";
import { BrowserRouter } from "react-router-dom";
import { MaintenanceProvider } from "./contexts/MaintenanceContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { NotificationsProvider } from "./contexts/NotificationsContext";
import AppRouter from "./components/AppRouter";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <BrowserRouter>
      <MaintenanceProvider>
        <AuthProvider>
          <ThemeProvider>
            <NotificationsProvider>
              <div className="min-h-screen bg-gray-50 dark:bg-gray-950 transition-colors duration-300">
                
                {/* ✅ React Hot Toast */}
                <Toaster
                  position="top-center"
                  toastOptions={{
                    duration: 4000,
                    style: {
                      borderRadius: "10px",
                      background: "#333",
                      color: "#fff",
                    },
                  }}
                />

                <AppRouter />
              </div>
            </NotificationsProvider>
          </ThemeProvider>
        </AuthProvider>
      </MaintenanceProvider>
    </BrowserRouter>
  );
}

export default App;